import {Button, Card, Menu, MenuItem, Text} from '@mc/ui-v4';
import React, {useState, useEffect, useMemo} from 'react';
import './ZoomSelector.scss';
import {useMapioContext} from '../../mapioContext';
import {useAppConfig} from '@mc/react-app-base';

type ZoomProps = {
    initialZoom: number;
    distanceData: DistanceData;
};

export type DistanceData = {
    currentDistance: string;
    currentPixelDistance: number;
    currentZoomLevel: number;
};

/**
 * Formátuje scale value na lidsky čitelný název
 * např. 1000.0 -> "1 : 1 000", 1.5 -> "1 : 1,5"
 */
const formatScaleName = (scale: number): string => {
    const formattedScale =
        scale >= 1000
            ? scale.toLocaleString('cs-CZ', {maximumFractionDigits: 0})
            : scale.toLocaleString('cs-CZ', {minimumFractionDigits: 0, maximumFractionDigits: 1});
    return `1 : ${formattedScale}`;
};

export const ZoomSelector: React.FC<ZoomProps> = ({initialZoom, distanceData}) => {
    const mapioContext = useMapioContext();
    const {mapRef} = mapioContext.value;
    const [activeScale, setActiveScale] = useState(distanceData?.currentZoomLevel ?? initialZoom);
    // @ts-ignore
    const {scales} = useAppConfig();

    // Vygenerování scale items pro menu
    const scaleItems = useMemo(() => {
        return scales?.map((scale, index) => ({
            id: index, // index odpovídá zoom level
            name: formatScaleName(scale),
            scale: scale,
        }));
    }, [scales]);

    useEffect(() => {
        setActiveScale(distanceData?.currentZoomLevel);
    }, [distanceData?.currentZoomLevel]);

    const handleZoomChange = (scaleId: number) => {
        setActiveScale(scaleId);
        mapRef?.current?.setZoom(scaleId);
    };

    return (
        <Card className={'scale-card drop-shadow'}>
            <Button
                menu={
                    <Menu>
                        <div className={'scale-dropdown'}>
                            {scaleItems?.map(scale => (
                                <MenuItem key={scale.id} text={scale.name} active={activeScale === scale.id} onClick={() => handleZoomChange(scale.id)} />
                            ))}
                        </div>
                    </Menu>
                }
            >
                <Text>{distanceData.currentDistance}</Text>
            </Button>
        </Card>
    );
};
